/**
 * VIVI Wishlist � guest localStorage list + drawer with quick buy.
 * API: window.ViviWishlist
 */
(function () {
  var KEY = 'vivi_wishlist';
  var MAX = 48;
  var root = null;
  var productCache = {};
  var activeElement = null;

  function strings() {
    return window.viviWishlistStrings || {};
  }

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    try {
      localStorage.setItem(KEY, JSON.stringify(items.slice(0, MAX)));
    } catch (e) {
      /* quota / private mode */
    }
  }

  function formatMoney(cents) {
    var iso =
      (window.Shopify && Shopify.currency && Shopify.currency.active) || 'PKR';
    var amount = (Number(cents) || 0) / 100;
    var noDecimals = iso === 'PKR';
    return (
      amount.toLocaleString(undefined, {
        minimumFractionDigits: noDecimals ? 0 : 2,
        maximumFractionDigits: noDecimals ? 0 : 2,
      }) +
      ' ' +
      iso
    );
  }

  function priceHtml(priceCents, compareCents) {
    var price = Number(priceCents) || 0;
    var compare = Number(compareCents) || 0;
    if (!price && !compare) {
      return '<p class="vivi-wishlist-drawer__price" data-vivi-wish-price hidden></p>';
    }
    if (compare > price && price > 0) {
      return (
        '<p class="vivi-wishlist-drawer__price vivi-wishlist-drawer__price--sale" data-vivi-wish-price>' +
        '<s class="vivi-wishlist-drawer__compare">' +
        escapeHtml(formatMoney(compare)) +
        '</s> ' +
        '<span class="vivi-wishlist-drawer__sale">' +
        escapeHtml(formatMoney(price)) +
        '</span>' +
        '</p>'
      );
    }
    return (
      '<p class="vivi-wishlist-drawer__price" data-vivi-wish-price>' +
      escapeHtml(formatMoney(price || compare)) +
      '</p>'
    );
  }

  function setPriceEl(priceEl, priceCents, compareCents) {
    if (!priceEl) return;
    var price = Number(priceCents) || 0;
    var compare = Number(compareCents) || 0;
    if (!price && !compare) {
      priceEl.hidden = true;
      priceEl.textContent = '';
      priceEl.classList.remove('vivi-wishlist-drawer__price--sale');
      return;
    }
    priceEl.hidden = false;
    if (compare > price && price > 0) {
      priceEl.classList.add('vivi-wishlist-drawer__price--sale');
      priceEl.innerHTML =
        '<s class="vivi-wishlist-drawer__compare">' +
        escapeHtml(formatMoney(compare)) +
        '</s> <span class="vivi-wishlist-drawer__sale">' +
        escapeHtml(formatMoney(price)) +
        '</span>';
    } else {
      priceEl.classList.remove('vivi-wishlist-drawer__price--sale');
      priceEl.textContent = formatMoney(price || compare);
    }
  }

  function productFromButton(btn) {
    if (!btn) return null;
    var id = parseInt(btn.getAttribute('data-product-id'), 10);
    var handle = btn.getAttribute('data-product-handle') || '';
    if (!id && !handle) return null;
    return {
      id: id || 0,
      handle: handle,
      title: btn.getAttribute('data-product-title') || '',
      url: btn.getAttribute('data-product-url') || (handle ? '/products/' + handle : ''),
      image: btn.getAttribute('data-product-image') || '',
      price: parseInt(btn.getAttribute('data-product-price'), 10) || 0,
      compare_at_price: parseInt(btn.getAttribute('data-product-compare-at'), 10) || 0,
    };
  }

  function persistItemPrices(handle, price, compareAt) {
    if (!handle) return;
    var items = read();
    var changed = false;
    items.forEach(function (item) {
      if (item.handle !== handle) return;
      if (Number(item.price) !== Number(price) || Number(item.compare_at_price || 0) !== Number(compareAt || 0)) {
        item.price = price;
        item.compare_at_price = compareAt || 0;
        changed = true;
      }
    });
    if (changed) write(items);
  }

  function sameProduct(a, b) {
    if (!a || !b) return false;
    if (a.id && b.id && Number(a.id) === Number(b.id)) return true;
    if (a.handle && b.handle && a.handle === b.handle) return true;
    return false;
  }

  function has(idOrProduct) {
    var items = read();
    if (typeof idOrProduct === 'object') {
      return items.some(function (item) {
        return sameProduct(item, idOrProduct);
      });
    }
    var id = Number(idOrProduct);
    return items.some(function (item) {
      return Number(item.id) === id;
    });
  }

  function add(product) {
    if (!product) return read();
    var items = read().filter(function (item) {
      return !sameProduct(item, product);
    });
    items.unshift({
      id: product.id,
      handle: product.handle,
      title: product.title,
      url: product.url,
      image: product.image,
      price: product.price,
      compare_at_price: product.compare_at_price || 0,
    });
    write(items);
    emit();
    return items;
  }

  function remove(idOrProduct) {
    var items = read().filter(function (item) {
      if (typeof idOrProduct === 'object') return !sameProduct(item, idOrProduct);
      return Number(item.id) !== Number(idOrProduct);
    });
    write(items);
    emit();
    return items;
  }

  function toggle(product) {
    if (!product) return { items: read(), added: false };
    if (has(product)) {
      return { items: remove(product), added: false };
    }
    return { items: add(product), added: true };
  }

  function count() {
    return read().length;
  }

  function emit() {
    document.dispatchEvent(
      new CustomEvent('vivi:wishlist:change', {
        detail: { items: read(), count: count() },
      })
    );
    syncUi();
  }

  function syncButtons() {
    var s = strings();
    document.querySelectorAll('[data-vivi-wish-toggle]').forEach(function (btn) {
      var product = productFromButton(btn);
      var on = has(product);
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = on
        ? btn.getAttribute('data-label-active') || s.remove || 'Remove from wishlist'
        : btn.getAttribute('data-label-add') || s.add || 'Add to wishlist';
      btn.setAttribute('aria-label', label);
      var labelEl = btn.querySelector('[data-vivi-wish-label]');
      if (labelEl) labelEl.textContent = label;
    });
  }

  function syncCounts() {
    var n = count();
    document.querySelectorAll('[data-vivi-wishlist-count]').forEach(function (el) {
      el.textContent = String(n);
      if (n > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(str) {
    return escapeHtml(str).replace(/'/g, '&#39;');
  }

  function fetchProduct(handle) {
    if (!handle) return Promise.reject(new Error('missing handle'));
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
    })
      .then(function (res) {
        if (!res.ok) throw new Error('product fetch failed');
        return res.json();
      })
      .then(function (data) {
        productCache[handle] = data;
        return data;
      });
  }

  function optionNames(product) {
    if (!product || !product.options) return [];
    return product.options.map(function (opt) {
      return typeof opt === 'string' ? opt : opt.name || '';
    });
  }

  function findVariant(product, selected) {
    if (!product || !product.variants) return null;
    return (
      product.variants.find(function (variant) {
        return selected.every(function (value, index) {
          return String(variant['option' + (index + 1)] || '') === String(value);
        });
      }) || null
    );
  }

  function firstAvailableSelection(product) {
    var names = optionNames(product);
    var available = (product.variants || []).find(function (v) {
      return v.available;
    });
    if (available) {
      return names.map(function (_, i) {
        return available['option' + (i + 1)] || '';
      });
    }
    var first = product.variants && product.variants[0];
    if (!first) return names.map(function () {
      return '';
    });
    return names.map(function (_, i) {
      return first['option' + (i + 1)] || '';
    });
  }

  function optionValues(product, optionIndex) {
    var values = [];
    (product.variants || []).forEach(function (variant) {
      var value = variant['option' + (optionIndex + 1)];
      if (value != null && value !== '' && values.indexOf(value) === -1) values.push(value);
    });
    return values;
  }

  function isValueAvailable(product, optionIndex, value, selected) {
    return (product.variants || []).some(function (variant) {
      if (!variant.available) return false;
      if (String(variant['option' + (optionIndex + 1)]) !== String(value)) return false;
      return selected.every(function (sel, i) {
        if (i === optionIndex) return true;
        if (!sel) return true;
        return String(variant['option' + (i + 1)] || '') === String(sel);
      });
    });
  }

  function renderItemShell(item, s) {
    var img = item.image
      ? '<img src="' +
        escapeAttr(item.image) +
        '" alt="" width="90" height="120" loading="lazy">'
      : '<span class="vivi-wishlist-drawer__ph" aria-hidden="true"></span>';
    return (
      '<li class="vivi-wishlist-drawer__item" data-product-id="' +
      escapeAttr(String(item.id || '')) +
      '" data-product-handle="' +
      escapeAttr(item.handle || '') +
      '">' +
      '<a class="vivi-wishlist-drawer__media" href="' +
      escapeAttr(item.url || '#') +
      '">' +
      img +
      '</a>' +
      '<div class="vivi-wishlist-drawer__meta">' +
      '<a class="vivi-wishlist-drawer__title" href="' +
      escapeAttr(item.url || '#') +
      '">' +
      escapeHtml(item.title || '') +
      '</a>' +
      priceHtml(item.price, item.compare_at_price) +
      '<div class="vivi-wishlist-drawer__quickbuy" data-vivi-wish-quickbuy>' +
      '<p class="vivi-wishlist-drawer__loading">' +
      escapeHtml(s.loading || 'Loading options...') +
      '</p>' +
      '</div>' +
      '<button type="button" class="vivi-wishlist-drawer__remove" data-vivi-wishlist-remove>' +
      escapeHtml(s.removeItem || 'Remove') +
      '</button>' +
      '</div>' +
      '</li>'
    );
  }

  function hydrateQuickBuy(row, product, savedItem) {
    var mount = row.querySelector('[data-vivi-wish-quickbuy]');
    var priceEl = row.querySelector('[data-vivi-wish-price]');
    var s = strings();
    if (!mount || !product) return;

    /* Paint product-level price immediately (fixes stale localStorage Rs.1 rows) */
    setPriceEl(priceEl, product.price, product.compare_at_price);
    persistItemPrices(product.handle, product.price, product.compare_at_price || 0);

    var names = optionNames(product);
    var selected = firstAvailableSelection(product);
    var hasRealOptions =
      names.length > 0 &&
      !(names.length === 1 && (product.variants || []).length === 1 && names[0] === 'Title');

    function currentVariant() {
      return findVariant(product, selected);
    }

    function updateUi() {
      var variant = currentVariant();
      mount.querySelectorAll('[data-vivi-wish-option-value]').forEach(function (btn) {
        var optIndex = parseInt(btn.getAttribute('data-option-index'), 10);
        var value = btn.getAttribute('data-vivi-wish-option-value');
        var selectedHere = String(selected[optIndex]) === String(value);
        var available = isValueAvailable(product, optIndex, value, selected);
        btn.classList.toggle('is-selected', selectedHere);
        btn.classList.toggle('is-unavailable', !available);
        btn.setAttribute('aria-pressed', selectedHere ? 'true' : 'false');
        btn.disabled = false;
      });

      if (priceEl && variant) {
        setPriceEl(priceEl, variant.price, variant.compare_at_price);
        persistItemPrices(product.handle, variant.price, variant.compare_at_price || 0);
      }

      var atc = mount.querySelector('[data-vivi-wish-atc]');
      if (!atc) return;
      atc.disabled = !variant || !variant.available;
      if (!variant) {
        atc.textContent = s.unavailable || 'Unavailable';
      } else if (!variant.available) {
        atc.textContent = s.soldOut || 'Sold out';
      } else {
        atc.textContent = s.addToBag || 'Add to bag';
      }
      atc.setAttribute('data-variant-id', variant && variant.available ? String(variant.id) : '');
    }

    var optionsHtml = '';
    if (hasRealOptions) {
      names.forEach(function (name, optIndex) {
        var values = optionValues(product, optIndex);
        if (!values.length) return;
        optionsHtml +=
          '<div class="vivi-wishlist-drawer__option" data-option-index="' +
          optIndex +
          '">' +
          '<p class="vivi-wishlist-drawer__option-label">' +
          escapeHtml(name) +
          '</p>' +
          '<div class="vivi-wishlist-drawer__pills" role="group" aria-label="' +
          escapeAttr(name) +
          '">';
        values.forEach(function (value) {
          optionsHtml +=
            '<button type="button" class="vivi-wishlist-drawer__pill" data-vivi-wish-option-value="' +
            escapeAttr(value) +
            '" data-option-index="' +
            optIndex +
            '">' +
            escapeHtml(value) +
            '</button>';
        });
        optionsHtml += '</div></div>';
      });
    }

    mount.innerHTML =
      optionsHtml +
      '<button type="button" class="vivi-wishlist-drawer__atc button" data-vivi-wish-atc>' +
      escapeHtml(s.addToBag || 'Add to bag') +
      '</button>' +
      '<p class="vivi-wishlist-drawer__status" data-vivi-wish-status hidden></p>';

    if (savedItem && savedItem.image && row.querySelector('.vivi-wishlist-drawer__media img') == null) {
      /* keep saved image */
    } else if (product.featured_image) {
      var media = row.querySelector('.vivi-wishlist-drawer__media');
      var imgUrl =
        typeof product.featured_image === 'string'
          ? product.featured_image
          : product.featured_image.src || '';
      if (media && imgUrl && !media.querySelector('img')) {
        media.innerHTML =
          '<img src="' + escapeAttr(imgUrl) + '" alt="" width="90" height="120" loading="lazy">';
      }
    }

    mount.addEventListener('click', function (event) {
      var pill = event.target.closest('[data-vivi-wish-option-value]');
      if (pill) {
        event.preventDefault();
        var optIndex = parseInt(pill.getAttribute('data-option-index'), 10);
        selected[optIndex] = pill.getAttribute('data-vivi-wish-option-value');
        updateUi();
        return;
      }

      var atc = event.target.closest('[data-vivi-wish-atc]');
      if (atc) {
        event.preventDefault();
        addVariantToCart(atc, mount);
      }
    });

    updateUi();
  }

  function setStatus(mount, message, isError) {
    var status = mount && mount.querySelector('[data-vivi-wish-status]');
    if (!status) return;
    if (!message) {
      status.hidden = true;
      status.textContent = '';
      return;
    }
    status.hidden = false;
    status.textContent = message;
    status.classList.toggle('is-error', !!isError);
  }

  function addVariantToCart(button, mount) {
    var s = strings();
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId || button.disabled) return;

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    button.disabled = true;
    button.classList.add('is-loading');
    button.textContent = s.adding || 'Adding...';
    setStatus(mount, '');

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map(function (section) {
          return section.id;
        })
      );
      formData.append('sections_url', window.location.pathname);
    }

    var config = {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/javascript',
      },
      body: formData,
    };

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', config)
      .then(function (res) {
        return res.json();
      })
      .then(function (response) {
        if (response.status) {
          setStatus(mount, response.description || response.message || s.addError || 'Could not add', true);
          button.disabled = false;
          button.textContent = s.addToBag || 'Add to bag';
          button.classList.remove('is-loading');
          return;
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'vivi-wishlist',
            productVariantId: variantId,
            cartData: response,
          });
        }

        if (cart && typeof cart.renderContents === 'function') {
          close();
          /* Dawn only clears is-empty on the inner drawer; host keeps is-empty after empty-cart sessions */
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(response);
        } else {
          setStatus(mount, s.added || 'Added to bag', false);
          button.textContent = s.added || 'Added';
          window.setTimeout(function () {
            button.disabled = false;
            button.textContent = s.addToBag || 'Add to bag';
            button.classList.remove('is-loading');
            setStatus(mount, '');
          }, 1600);
          return;
        }

        button.classList.remove('is-loading');
      })
      .catch(function () {
        setStatus(mount, s.addError || 'Could not add', true);
        button.disabled = false;
        button.textContent = s.addToBag || 'Add to bag';
        button.classList.remove('is-loading');
      });
  }

  function renderDrawer() {
    if (!root) return;
    var list = root.querySelector('[data-vivi-wishlist-list]');
    var empty = root.querySelector('[data-vivi-wishlist-empty]');
    var items = read();
    var s = strings();

    if (!list) return;

    if (!items.length) {
      list.innerHTML = '';
      if (empty) empty.hidden = false;
      root.classList.add('is-empty');
      return;
    }

    root.classList.remove('is-empty');
    if (empty) empty.hidden = true;

    list.innerHTML = items
      .map(function (item) {
        return renderItemShell(item, s);
      })
      .join('');

    items.forEach(function (item) {
      var row = list.querySelector(
        '.vivi-wishlist-drawer__item[data-product-handle="' + escapeAttr(item.handle || '') + '"]'
      );
      if (!row || !item.handle) return;
      fetchProduct(item.handle)
        .then(function (product) {
          if (!root || !root.classList.contains('active')) return;
          if (!row.isConnected) return;
          hydrateQuickBuy(row, product, item);
        })
        .catch(function () {
          var mount = row.querySelector('[data-vivi-wish-quickbuy]');
          if (!mount) return;
          mount.innerHTML =
            '<a class="vivi-wishlist-drawer__atc button" href="' +
            escapeAttr(item.url || '/products/' + item.handle) +
            '">' +
            escapeHtml(s.viewProduct || 'View product') +
            '</a>';
        });
    });
  }

  function syncUi() {
    syncButtons();
    syncCounts();
    if (root && root.classList.contains('active')) renderDrawer();
  }

  function open(triggeredBy) {
    if (!root) root = document.querySelector('vivi-wishlist-drawer');
    if (!root) return;
    if (triggeredBy) activeElement = triggeredBy;
    else if (document.activeElement instanceof HTMLElement) activeElement = document.activeElement;

    renderDrawer();
    root.classList.add('active');
    document.documentElement.classList.add('vivi-wishlist-open');
    document.body.classList.add('overflow-hidden');
    if (window.ViviScrollLock) window.ViviScrollLock.lock();

    var panel = root.querySelector('.vivi-wishlist-drawer__panel');
    var closeBtn = root.querySelector('[data-vivi-wishlist-close-btn]');
    var focusTarget = closeBtn || panel || root;

    var trap = function () {
      if (typeof trapFocus === 'function') {
        trapFocus(root, focusTarget);
      } else if (focusTarget && typeof focusTarget.focus === 'function') {
        focusTarget.focus();
      }
    };

    root.addEventListener('transitionend', trap, { once: true });
    window.setTimeout(trap, 320);

    document.dispatchEvent(new CustomEvent('vivi:wishlist:open'));
  }

  function close() {
    if (!root) root = document.querySelector('vivi-wishlist-drawer');
    if (!root) return;
    root.classList.remove('active');
    document.documentElement.classList.remove('vivi-wishlist-open');
    if (window.ViviScrollLock) window.ViviScrollLock.unlock();
    else document.body.classList.remove('overflow-hidden');
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(activeElement);
    } else if (activeElement && typeof activeElement.focus === 'function') {
      activeElement.focus();
    }
    activeElement = null;
    document.dispatchEvent(new CustomEvent('vivi:wishlist:close'));
  }

  function isOpen() {
    return !!(root && root.classList.contains('active'));
  }

  window.ViviWishlist = {
    get: read,
    has: has,
    add: add,
    remove: remove,
    toggle: toggle,
    count: count,
    open: open,
    close: close,
    isOpen: isOpen,
    sync: syncUi,
  };

  function onReady() {
    root = document.querySelector('vivi-wishlist-drawer');
    syncUi();

    document.addEventListener('click', function (event) {
      var toggleBtn = event.target.closest('[data-vivi-wish-toggle]');
      if (toggleBtn) {
        event.preventDefault();
        event.stopPropagation();
        toggle(productFromButton(toggleBtn));
        return;
      }

      var openBtn = event.target.closest('[data-vivi-wishlist-open]');
      if (openBtn) {
        event.preventDefault();
        open(openBtn);
        return;
      }

      var removeBtn = event.target.closest('[data-vivi-wishlist-remove]');
      if (removeBtn) {
        event.preventDefault();
        var row = removeBtn.closest('.vivi-wishlist-drawer__item');
        if (!row) return;
        remove({
          id: parseInt(row.getAttribute('data-product-id'), 10) || 0,
          handle: row.getAttribute('data-product-handle') || '',
        });
        return;
      }

      if (event.target.closest('[data-vivi-wishlist-close]')) {
        close();
      }
    });

    document.addEventListener('keyup', function (event) {
      if (event.code === 'Escape' && isOpen()) close();
    });

    window.addEventListener('storage', function (event) {
      if (event.key === KEY) syncUi();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
